<template>
  <v-container class="d-flex align-center justify-center" style="min-height: 80vh;">
    <v-col cols="12" sm="8" md="6" lg="4">
      <v-card elevation="2" rounded="lg" class="pa-6 text-center">
        <!-- Loading State -->
        <div v-if="loading">
          <v-progress-circular indeterminate color="primary" size="60" class="mb-4"></v-progress-circular>
          <v-card-title class="text-h5">Autentificare in curs...</v-card-title>
          <v-card-text class="text-grey">Va rugam asteptati.</v-card-text>
        </div>

        <!-- Error State -->
        <div v-else-if="error">
          <v-icon color="error" size="60" class="mb-4">mdi-alert-circle</v-icon>
          <v-card-title class="text-h5 text-error">Eroare Autentificare</v-card-title>
          <v-card-text>
            <v-alert type="error" variant="tonal" class="mb-4">
              {{ errorMessage }}
            </v-alert>
            <v-btn color="primary" variant="flat" @click="goToLogin">
              Inapoi la Login
            </v-btn>
          </v-card-text>
        </div>

        <!-- Success (brief flash before redirect) -->
        <div v-else-if="success">
          <v-icon color="success" size="60" class="mb-4">mdi-check-circle</v-icon>
          <v-card-title class="text-h5 text-success">Autentificare Reusita</v-card-title>
          <v-card-text>
            <div class="mb-2">Logat ca: <strong>{{ targetUserName }}</strong></div>
            <div class="text-grey">Redirectionare catre dashboard...</div>
          </v-card-text>
        </div>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue';
import { loginWithImpersonationToken } from "@/composables/useImpersonation";
import { log } from "@/composables/useLog";
import store from "@/store";

export default defineComponent({
  name: 'ImpersonateLogin',
  data() {
    return {
      loading: true,
      error: false,
      success: false,
      errorMessage: '',
      targetUserName: ''
    };
  },
  methods: {
    goToLogin() {
      this.$router.push('/');
    },
    async processImpersonationLogin() {
      const token = this.$route.query.token;

      if (!token) {
        this.loading = false;
        this.error = true;
        this.errorMessage = 'Token de impersonare lipseste';
        return;
      }

      log("Processing impersonation token");

      try {
        const result = await loginWithImpersonationToken(token);

        if (result.error) {
          this.loading = false;
          this.error = true;
          this.errorMessage = result.message || 'Autentificare esuata';
          return;
        }

        // Success - store user data in sessionStorage via store mutation
        store.commit('setImpersonationSession', {
          token: result.token,
          user: result.user
        });

        this.targetUserName = result.user.name || result.user.username || result.user.email;
        this.loading = false;
        this.success = true;

        // Redirect to dashboard after brief success display
        setTimeout(() => {
          this.$router.replace({ path: '/dashboard' });
        }, 800);

      } catch (err) {
        log("Error processing impersonation:", err);
        this.loading = false;
        this.error = true;
        this.errorMessage = 'A aparut o eroare neasteptata';
      }
    }
  },
  created() {
    this.processImpersonationLogin();
  }
});
</script>
